// extracted by css-extract-rspack-plugin
var _1 = "aFJj5u2tmzEhBU1m";
var _2 = "VC_R1dzHtd0g7YI7";
export { _1 as "modalCloseButtonStyle", _2 as "wrapper" }
